import { ReviewType } from '..';
import Stars from './Stars';

type ReviewPropsType = {
  review: ReviewType;
};

const Review = ({ review }: ReviewPropsType) => {
  return (
    <li className="pb-16 border-b border-b-gray last:border-b-none  mb-16">
      <h4 className="text-blue">{review.name}</h4>
      <Stars stars={review.stars} />
      <p>{review.review}</p>
    </li>
  );
};

export default Review;
